import { Component, OnInit, Input, Output, EventEmitter, HostListener, TemplateRef, HostBinding } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, AbstractControl, FormControl } from '@angular/forms';
import { FormToolsService } from '../core';

@Component({
  selector: 'atn-array-box',
  templateUrl: './array-box.component.html',
  styleUrls: ['./array-box.component.scss'],
  host: {
    '[class.with-title]': 'this.title'
  }
})
export class ArrayBoxComponent implements OnInit {
  @Input('tpl') templateRef: TemplateRef<any>;
  @Input('array') formArray: FormArray;
  @Input('form') getForm;
  @Input() sortable: boolean = true;
  @Input() duplicable: boolean = true;
  @Input() dark: boolean = false;
  @Input() title: string = null;

  @HostBinding('style.maxHeight')
  @Input() height: string = 'auto';

  draggedItem: number = null;

  constructor(
    private fb: FormBuilder,
    private ft: FormToolsService
  ) {}

  ngOnInit() {}

  addItem() {
    const form: FormGroup = this.getForm();

    if (this.sortable) {
      form.get('position').patchValue(this.formArray.controls.length + 1);
    }

    this.formArray.push(form);
  }

  removeItem($event, i: number) {

    $event.stopPropagation();

    this.formArray.removeAt(i);

    if (this.sortable) {
      this.formArray = this.ft.updatePositionsFormArray(this.formArray);
    }
  }

  duplicateItem($event, i: number) {

    $event.stopPropagation();

    const source = this.formArray.at(i);

    const copyFormControl = (control: AbstractControl, ignoreValue: boolean = false) => {
      if (control instanceof FormControl) {
          return new FormControl(ignoreValue ? null : control.value);
      } else if (control instanceof FormGroup) {
          const copy = new FormGroup({});
          Object.keys(control.getRawValue()).forEach(key => {
            if (key === '_id') {
              copy.addControl(key, copyFormControl(control.controls[key], true));
            } else {
              copy.addControl(key, copyFormControl(control.controls[key]));
            }
          });
          return copy;
      } else if (control instanceof FormArray) {
          const copy = new FormArray([]);
          control.controls.forEach(item => {
              copy.push(copyFormControl(item));
          })
          return copy;
      }
    }

    this.formArray.insert(i + 1, copyFormControl(source));

    if (this.sortable) {
      this.formArray = this.ft.updatePositionsFormArray(this.formArray);
    }

    return false;
  }

  dragItem(e: Event, i: number) {
    e.stopPropagation();
    this.draggedItem = i;
  }

  dropItem(e: Event, i: number) {
    e.stopPropagation();
    this.formArray = this.ft.reorderFormArray(this.formArray, this.draggedItem, i);
    this.draggedItem = null;
  }

  @HostListener('document:click', ['$event']) cancelDrag(e) {
    if (this.draggedItem !== null) {
      e.preventDefault();
      this.draggedItem = null;
    }
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/array-box/array-box.component.ts